<div class="milestones-banner {{
    slideCount ? 'slides-' + slideCount + ' wrapped' : ''
  }}" [ngClass]="page && milestones.length > 4 ? page : ''">
  @if (page === 'profiles-milestones') {
    @for (milestone of calcNumberOfMilestones(); track milestone; let i = $index) {
      <div class="milestone-container"
        title="{{ milestone['customer_milestone_description'] }}">
        <img [class.image-locked]="!completed_milestones.includes(milestone.id)" [src]="milestone['badge_image']"
          (click)="showMilestone(i)" />
        <p class="mat-body-medium" color="mat-primary">
          {{ milestone["internal_milestone_name"] }}
        </p>
        @if (i == 4 && showMilestoneOverlay) {
          <p (click)="showMilestone(i)" class="extra-text-profile">
            +{{extraMilestones}}
          </p>
        }
      </div>
    }
  }

  @if (!page || page !== 'profiles-milestones') {
    @for (milestone of calcNumberOfMilestones(); track milestone; let i = $index) {
      <div class="milestone-container">
        <img [class.image-locked]="!completed_milestones.includes(milestone.id)" [src]="milestone['badge_image']"
          title="{{ milestone['customer_milestone_description'] }}" (click)="showMilestone(i)" />
        @if (i == 4 && showMilestoneOverlay) {
          <p (click)="showMilestone(i)" class="u-text-color_white extra-text">
            +{{extraMilestones}}
          </p>
        }
      </div>
    }
  }
</div>